// Diagnostics feature flag.
//
// The diagnostics report buttons ship to production but stay hidden by default.
// Visit any page once with `?diag=1` to enable them (the choice is saved to
// localStorage so it sticks); `?diag=0` turns them back off. Everyone else
// never sees the buttons.
const FLAG_KEY = "junkball_diag";

/**
 * Sync the diagnostics flag from the URL. `?diag=1` enables (persisted to
 * localStorage), `?diag=0` clears it. Call once on app load.
 */
export function syncDiagnosticsFlag() {
  try {
    const v = new URLSearchParams(window.location.search).get("diag");
    if (v === "1") localStorage.setItem(FLAG_KEY, "1");
    else if (v === "0") localStorage.removeItem(FLAG_KEY);
  } catch {
    // ignore — private mode / disabled storage
  }
}

/** True when the diagnostics report UI should be shown on this device. */
export function diagnosticsEnabled() {
  try {
    return localStorage.getItem(FLAG_KEY) === "1";
  } catch {
    return false;
  }
}
